import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutData } from '@/mocks/about';

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 51爆料网 | 品牌介绍、口碑声誉与联系方式';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '了解51爆料网的品牌故事、核心优势、用户口碑与联系方式。全网最速吃瓜平台，一手黑料不容错过。每日实时更新网红明星最新爆料。');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'http://heiliaobao.cn/about');
    }
  }, []);

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51爆料网',
    url: 'http://heiliaobao.cn/',
    description: '51爆料网每日实时更新网红明星黑料、吃瓜大瓜与每日大赛独家爆料',
    foundingDate: '2023-03',
    founder: {
      '@type': 'Person',
      name: aboutData.brandIntro.founder.name,
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '建国路88号SOHO现代城A座1508室',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-5151',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
      email: 'hello@heiliaobao.cn',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: aboutData.faq.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <main>
        <Navbar />

        <section className="w-full pt-24 md:pt-28 pb-10 md:pb-14">
          <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ name: '首页', path: '/' }, { name: '关于我们' }]} />

            <div className="flex flex-col lg:flex-row gap-10 mt-8">
              <div className="lg:w-3/5">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 text-xs font-medium rounded-full">
                  {aboutData.brandIntro.tag}
                </span>
                <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mt-4 mb-4 leading-[1.1]">
                  {aboutData.brandIntro.slogan}
                </h1>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                  {aboutData.brandIntro.description}
                </p>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {aboutData.brandIntro.mission}
                </p>
              </div>

              <aside className="lg:w-2/5">
                <div className="bg-secondary-100/60 rounded-2xl p-6 md:p-8">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-xs text-secondary-700 font-medium bg-secondary-200/60 px-2 py-0.5 rounded-full">
                      品牌使命
                    </span>
                    <span className="flex gap-0.5">
                      <span className="w-1 h-1 rounded-full bg-secondary-400"></span>
                      <span className="w-1 h-1 rounded-full bg-secondary-400"></span>
                      <span className="w-1 h-1 rounded-full bg-secondary-400"></span>
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed mb-6">
                    我们的使命是打破信息壁垒，让每一个热爱八卦、关心娱乐的吃瓜群众都能第一时间获取最真实的资讯。我们坚信，真相不应该被资本和权势掩盖，每一个瓜都值得被认真对待。
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <img
                        src={aboutData.brandIntro.founder.avatar}
                        alt={aboutData.brandIntro.founder.name}
                        className="w-10 h-10 rounded-full object-cover object-top"
                      />
                      <div>
                        <p className="text-sm font-semibold text-foreground-950">
                          {aboutData.brandIntro.founder.name}
                        </p>
                        <p className="text-xs text-foreground-500">
                          {aboutData.brandIntro.founder.role}
                        </p>
                      </div>
                    </div>
                    <Link
                      to="/"
                      className="px-4 py-1.5 bg-secondary-200/50 text-secondary-800 rounded-full text-xs font-medium hover:bg-secondary-300/50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      浏览首页
                      <span className="w-3 h-3 inline-flex items-center justify-center ml-0.5">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 border border-primary-300 text-primary-600 text-xs font-semibold rounded-full">
                我们的优势
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mt-3">
                为什么选择51爆料
              </h2>
              <p className="text-foreground-500 text-sm mt-2 max-w-lg mx-auto">
                六大核心优势，让你吃瓜快人一步
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {aboutData.advantages.map((item, index) => (
                <div
                  key={index}
                  className="group flex flex-col p-5 rounded-xl bg-background-50 border border-background-200/70 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 cursor-default"
                >
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300 mb-4">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-base font-semibold text-foreground-950 group-hover:text-background-50 transition-colors mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-10 md:py-14">
          <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                数据见证实力
              </h2>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {aboutData.stats.map((stat, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70"
                >
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                    <i className={`${stat.icon} text-xl`}></i>
                  </span>
                  <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500 mt-1">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="mt-14">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
                发展历程
              </h3>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300/60 transform md:-translate-x-px"></div>
                <div className="space-y-6">
                  {aboutData.timeline.map((item, index) => (
                    <div
                      key={index}
                      className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                        index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                      }`}
                    >
                      <div className="flex items-center gap-4 md:w-1/2 md:justify-end">
                        <div className="md:hidden w-3 h-3 rounded-full bg-primary-500 flex-shrink-0 ml-1.5"></div>
                        <div className={`${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} flex-1`}>
                          <span className="text-xs font-semibold text-primary-500">{item.year}</span>
                          <p className="text-sm text-foreground-600 mt-1">{item.event}</p>
                        </div>
                      </div>
                      <div className="hidden md:flex items-center justify-center w-0 flex-shrink-0">
                        <div className="w-4 h-4 rounded-full bg-primary-500 border-4 border-background-100 z-10"></div>
                      </div>
                      <div className="md:w-1/2"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative w-full py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20cinematic%20scene%20with%20spotlight%20beam%20and%20anonymous%20silhouette%20with%20megaphone%20urban%20night%20atmosphere%20mysterious%20mood%20with%20warm%20accents%20editorial%20photography%20breaking%20news%20vibe&width=1600&height=600&seq=about-cta-bg&orientation=landscape"
              alt="商业合作与爆料投稿"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
          </div>

          <div className="relative z-10 w-full max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="flex flex-col items-start gap-8 max-w-2xl">
              <h2 className="text-4xl md:text-6xl font-heading font-bold text-background-50 leading-[1.05] lowercase">
                合作与投稿
              </h2>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-primary-100 transition-all duration-200 cursor-pointer whitespace-nowrap group"
              >
                联系我们
                <span className="w-5 h-5 flex items-center justify-center bg-foreground-950 text-background-50 rounded-full group-hover:bg-primary-500 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </Link>
              <p className="text-background-100/70 text-sm md:text-base leading-relaxed max-w-sm">
                商务合作：hello@heiliaobao.cn<br />
                爆料投稿：hello@heiliaobao.cn<br />
                24小时内回复您的来信
              </p>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                联系我们
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <div className="flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-map-pin-line text-xl"></i>
                </span>
                <h4 className="text-sm font-semibold text-foreground-950 mb-1">公司地址</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">{aboutData.contactInfo.address}</p>
              </div>
              <div className="flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-phone-line text-xl"></i>
                </span>
                <h4 className="text-sm font-semibold text-foreground-950 mb-1">联系电话</h4>
                <p className="text-xs text-foreground-500">{aboutData.contactInfo.phone}</p>
                <p className="text-xs text-foreground-400 mt-1">{aboutData.contactInfo.businessHours}</p>
              </div>
              <div className="flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <h4 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h4>
                <p className="text-xs text-foreground-500">{aboutData.contactInfo.email}</p>
                <p className="text-xs text-foreground-400 mt-1">微博：{aboutData.contactInfo.weibo}</p>
              </div>
            </div>

            <div className="bg-background-100 rounded-2xl p-8 md:p-12">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
                常见问题
              </h3>
              <div className="max-w-3xl mx-auto space-y-5">
                {aboutData.faq.map((item, index) => (
                  <div key={index} className="border-b border-background-200/70 pb-5 last:border-0">
                    <h4 className="text-sm md:text-base font-semibold text-foreground-950 mb-2">
                      {item.question}
                    </h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}